export enum ToolbarButtonEnum {
  None = 0,
  Menu = 1,
  Back = 2,
  Home = 3,
}
